import api from './api';

const quienesSomosService = {
  get: async () => {
    const response = await api.get('/quienes-somos');
    return response.data;
  },
  update: async (data) => {
    const response = await api.put('/quienes-somos', data);
    return response.data;
  }
};

export default quienesSomosService;
